import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectRevokedList } from 'features/accessControl/ducks/selectors'
import { getRevokedListForBpRoutine } from 'features/accessControl/ducks/actions'
import { unitAccessFetchRevokedRoutine } from 'ducks/units/actions'
import { selectUnitRevokedList } from 'ducks/units/selectors'
import { isNotNilOrEmpty } from 'utils/ramda'
import { getSelectedBp } from 'features/bpDetails/ducks/selectors'
import { filterOutStaff } from 'utils/user'
import RevokedSection from './RevokedBox'

const RevokedList = ({ unit, canAccept, items, onRestore, onRemove, onCountChange = () => {} }) => {
  const bp = useSelector(getSelectedBp)
  const bpRevokedUsers = useSelector(selectRevokedList)
  const unitRevokedUsers = useSelector(selectUnitRevokedList)
  const dispatch = useDispatch()

  const selectorRevokedUsers = useMemo(() => {
    return isNotNilOrEmpty(unit) ? unitRevokedUsers : bpRevokedUsers
  }, [bpRevokedUsers, unitRevokedUsers, unit])

  const revokedUsers = useMemo(
    () => filterOutStaff(items != null ? items : (selectorRevokedUsers || [])) || [],
    [items, selectorRevokedUsers]
  )

  useEffect(() => {
    if (items != null) return
    if (unit) {
      dispatch(unitAccessFetchRevokedRoutine.trigger({ bpId: bp.id, unitId: unit.id }))
    } else if (bp) {
      dispatch(getRevokedListForBpRoutine(bp.id))
    }
  }, [unit, bp, dispatch, items])

  useEffect(() => {
    onCountChange(Array.isArray(revokedUsers) ? revokedUsers.length : 0)
  }, [revokedUsers, onCountChange])

  return (
    <RevokedSection
      users={revokedUsers || []}
      unit={unit}
      canAccept={canAccept}
      onRestore={onRestore}
      onRemove={onRemove}
      onCountChange={onCountChange}
    />
  )
}

export default RevokedList
